import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOppBotMutations } from "../hooks/useOppBotApi";

// Dev / QA helper: push a saved .eml through the same ingestion path as the webhook.
export default function EmlUploader({ compact }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [force, setForce] = useState(false);
  const { testIngest } = useOppBotMutations();
  const navigate = useNavigate();

  const onFile = async (file) => {
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      const res = await testIngest(file, { forceReprocess: force });
      if (res && res.id) navigate(`/landmark/oppbot/email/${res.id}`);
    } catch (e) {
      setError(e.message || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className={`ob-uploader ${compact ? "ob-uploader--compact" : ""}`}>
      <input ref={inputRef} type="file" accept=".eml,message/rfc822" style={{ display: "none" }} onChange={(e) => onFile(e.target.files && e.target.files[0])} />
      <button type="button" className="ob-btn ob-btn--sm" disabled={busy} onClick={() => inputRef.current && inputRef.current.click()} title="Ingest a saved .eml file exactly as if it had been forwarded to the bot">
        {busy ? "Ingesting…" : "Test with .eml"}
      </button>
      {!compact && (
        <label className="ob-check">
          <input type="checkbox" checked={force} onChange={(e) => setForce(e.target.checked)} />
          <span>allow duplicate</span>
        </label>
      )}
      {error && <span className="ob-inline-error">{error}</span>}
    </div>
  );
}
